import {Grid, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {memo} from 'react'

import {Body, Header, Skeleton, Tabs} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import iconSrc from './assets/Delivery.svg'
import {CargoRequirements} from './CargoRequirements/CargoRequirements'
import {CourierInfo} from './CourierInfo/CourierInfo'
import {DeliveryDirectionVerticals} from './DeliveryDirectionVerticals/DeliveryDirectionVerticals'
import {useVerticals} from './hooks'
import type {Props} from './types'

export const Verticals = memo<Props>(function Verticals({children}) {
  const {preparedVerticalGroups, verticalName, isVerticalsPending, handleVerticalDirectionSelect} = useVerticals()

  return (
    <Paper radius="L">
      <Grid size="m" container>
        <Grid xs={12} item>
          <Header
            lead={<img alt="" height={spacing(4.5)} loading="lazy" src={iconSrc} width={spacing(4.25)} />}
            tail={children}
          >
            <Typography group="tight" thickness="medium" variant="title4">
              {i18n('cargo.create.form.order', 'Заказать')}
            </Typography>
          </Header>
        </Grid>
        {preparedVerticalGroups.length > 1 && (
          <Grid xs={12} item>
            <Body
              tail={
                isVerticalsPending ? (
                  <Skeleton height={6} />
                ) : (
                  <Tabs
                    data-e2e="tabs-city-or-country"
                    items={preparedVerticalGroups}
                    name="offerFlow.deliveryDirection"
                    onChange={handleVerticalDirectionSelect}
                  />
                )
              }
            />
          </Grid>
        )}
        <Grid xs={12} item>
          <Body tail={<DeliveryDirectionVerticals />} />
        </Grid>
        {verticalName === 'cargo' && (
          <Grid xs={12} item>
            {isVerticalsPending ? <Body tail={<Skeleton height={17} />} /> : <CargoRequirements />}
          </Grid>
        )}

        {verticalName === 'walking_courier' && (
          <Grid xs={12} item>
            {isVerticalsPending ? <Body tail={<Skeleton height={17} />} /> : <CourierInfo />}
          </Grid>
        )}
      </Grid>
    </Paper>
  )
})
